define('modules/editor/models/property_groups/text_content',['require','exports','module','./base','lib/util','../../behaviours/apply_content'],function(require, exports, module) {
  var BasePropertyGroup = require("./base"),
      util = require("lib/util");

  module.exports = BasePropertyGroup.extend({
    name: "text:content",
    editAllowed: false,
    properties: ["content"]
  });

  util.mixin(module.exports, require("../../behaviours/apply_content"));
});

